'use client';

import { useEffect, useState } from 'react';
import { FiMinus, FiPlus } from 'react-icons/fi';
import SectionTitle from './SectionTitle';

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQProps {
    faqData?: FAQItem[];
    title?: string;
    description?: string;
    FAQCTA?: string;
}

const FAQ = ({
    faqData = [],
    title = "FAQ",
    description = "",
    FAQCTA: _FAQCTA = ""
}: FAQProps) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    // Set first question open by default when FAQ data is available
    useEffect(() => {
        if (faqData && faqData.length > 0 && openIndex === null) {
             
            setOpenIndex(0);
        }
    }, [faqData, openIndex]);

    const toggleAccordion = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    // If no FAQ data is provided, don't render the component
    if (!faqData || faqData.length === 0) {
        return null;
    }

    return (
        <section className=" py-4 md:py-8 lg:py-16 xl:py-0 section-bg-white relative overflow-hidden " data-interlink-allow="faq">
            <div className="relative custom-container mx-auto">

                {/* Main Content */}
                <div className="mx-auto grid grid-cols-1 lg:grid-cols-12 lg:gap-12 items-center py-10 md:py-0 ">
                    {/* Left column */}
                    <div className="lg:col-span-4 flex flex-col justify-center h-full mb-5">
                        <SectionTitle
                            title={title}
                            description={description}
                            align="left"
                        />


                    </div>

                    {/* Right column */}
                    <div className="lg:col-span-8 border border-[#1D214B]/8 px-4 sm:px-6 md:px-10 xl:py-12 py-0 bg-[#ebebeb]/10 backdrop-blur-sm">
                        {faqData.map((item, index) => (
                            <div
                                key={index}
                                className="border-b border-[#cbcbcb]/50 last:border-b-0 py-4 sm:py-6"
                            >
                                <button
                                    onClick={() => toggleAccordion(index)}
                                    className="flex items-center justify-between w-full text-left hover:cursor-pointer"
                                >
                                    <span className=" text-sm sm:text-base md:text-lg font-semibold text-[#1b1b1b]">
                                        {item.question}
                                    </span>
                                    <span className="ml-4 shrink-0">
                                        {openIndex === index ? (
                                            <FiMinus className="h-5 w-5 text-[#1b1b1b]" />
                                        ) : (
                                            <FiPlus className="h-5 w-5 text-[#1b1b1b]" />
                                        )}
                                    </span>
                                </button>

                                {openIndex === index && (
                                    <div className=" mt-2 sm:mt-4">
                                        <div
                                            className="text-gray-600 text-sm sm:text-base leading-relaxed prose prose-sm max-w-none"
                                            dangerouslySetInnerHTML={{ __html: item.answer }}
                                        />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQ;
